import {
  MappedPanelError,
  mapPanelError,
  PanelErrorRoute,
} from "../panelErrors";
import { CASHBACK_ERROR_ROUTES } from "../cashbackFunding";
import { HoldingFormValues } from "./types";

export type HoldingErrorField = keyof HoldingFormValues;

export type MappedHoldingTradeError = MappedPanelError<HoldingErrorField>;

// `HoldingValuationUnavailableError`'s three messages don't mean the same thing: the selected instrument being
// unpriced goes to that field, but some *other* holding failing the rollup goes to the banner instead.
const ROUTES: readonly PanelErrorRoute<HoldingErrorField>[] = [
  // Service-level guards.
  ["Cannot execute trade on", "instrument"],
  ["Cannot value holdings", null],
  ["Trade date", "date"],
  ["Trade quantity", "quantity"],
  ["Trade amount", "amountEur"],
  // DTO constraint messages, matched on their field prefix.
  ["Quantity ", "quantity"],
  ["Amount ", "amountEur"],
  ["Fee ", "feeEur"],
  ...CASHBACK_ERROR_ROUTES,
  ["Instrument ", "instrument"],
  ["Effective date ", "date"],
];

export const mapHoldingTradeError = (
  messages: string[],
): MappedHoldingTradeError => mapPanelError(messages, ROUTES);
